import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import '../styles/not-found.css'
import NotFoundImage from '../assets/not-found.svg'
import { baseButtonWhiteBg } from '../theme/custom-styles'

const NotFound = () => {
  const navigate = useNavigate()
  const { t } = useTranslation(['not-found'])

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <img
          src={NotFoundImage}
          alt="not-found"
        />
        <div className="not-found-info-container">
          <div className="not-found-info-title">{t('title')}</div>
          <div className="not-found-info-text">{t('description')}</div>
        </div>
        <div className="not-found-action-button">
          <Button
            variant="contained"
            sx={baseButtonWhiteBg}
            onClick={() => navigate('/', { replace: true })}
          >
            {t('actionButtonText')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default NotFound
